import React from "react";
import LoadingGif from "../assets/animations/loading.gif";

export default function ModalLoading({
  showModal,
  setShowModal,
  loadingState,
}) {
  return (
    showModal && (
      <div className="fixed inset-0 left-0 top-0 z-[100] flex h-screen w-screen flex-col items-center justify-center bg-transparent-black-20 backdrop-blur-sm transition-background">
        <img
          src={LoadingGif}
          alt="Loading..."
          className={`w-20 transition-opacity duration-500 ${showModal ? "opacity-100" : "opacity-0"}`}
        />
        {loadingState && (
          <div className="rounded-lg bg-white px-4 py-3 shadow-lg">
            <p>{loadingState}</p>
          </div>
        )}
      </div>
    )
  );
}
